module.exports = __webpack_public_path__ + "610f56ae8ba4c6ae8de47331a1f2811c.jpg";